<page-title text="Fees | BitOasis" i18n-text="@@pageTitle.fees"></page-title>
<page-meta description="BitOasis offers a nominal fee on your trades. Compare trading, deposit & withdrawal fees and check the fee structure for all our offerings in one place" i18n-description="@@fees.description"></page-meta>

<ng-container *ngIf="{isMobileWebView : isMobileWebView$ | async} as vm">
  <site-layout class="white full" [hideHeader]="vm.isMobileWebView">
    <loading *ngIf="loading" class="full" i18n="@@fees.loading">Loading Data</loading>

    <div *ngIf="!loading">
      <page-header
        contentTitle="BitOasis Fees"
        contentDescription="Enjoy the most competitive fees in the region whether you want to buy, sell or swap cryptocurrencies, or if you want to deposit/withdraw fiat."
        i18n-contentTitle="@@fees.header.title"
        i18n-contentDescription="@@fees.header.info"
      ></page-header>

      <error *ngIf="error" class="full">
        {{error}}
      </error>

      <div *ngIf="!error">
        <main>
          <div class="container">
            <page-notification location="FEES"></page-notification>
          </div>

          <fees-tabs (change)="handleTabChange($event)" class="my-3 tabs-sticky" [class.mobile]="vm.isMobileWebView"></fees-tabs>
          <ng-container [ngSwitch]="selectedTab">
            <ng-container *ngSwitchCase="FeeTabs.Trade">
              <div class="container">
                <fees-trading
                  [tradeFees]="cryptoFees?.tradeFees"
                  [last30DaysVolume]="cryptoFees?.last30DaysVolume"
                  [fiatCurrency]="fiatCurrency"
                  [country]="country"
                >
                  <ng-template #start>
                    <ng-container *ngTemplateOutlet="startButton; context: { url: '/lite' }"></ng-container>
                  </ng-template>
                </fees-trading>
              </div>
              <ng-container *ngTemplateOutlet="startButtonArea; context: { url: '/pro' }"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="FeeTabs.Crypto">
              <div class="container">
                <fees-crypto [withdrawalFees]="cryptoFees?.withdrawalFees"></fees-crypto>
              </div>
              <ng-container *ngTemplateOutlet="startButtonArea; context: { url: '/lite' }"></ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="container">
                <fees-fiat [fiatFees]="fiatFees" [fiatCurrency]="fiatCurrency" [country]="country"></fees-fiat>
              </div>
              <ng-container *ngTemplateOutlet="startButtonArea; context: { url: '/accounts' }"></ng-container>
            </ng-container>
          </ng-container>
        </main>
      </div>
    </div>
  </site-layout>
  <site-footer *ngIf="!vm.isMobileWebView"></site-footer>

  <ng-template #startButtonArea let-url="url">
    <div class="button-wrapper" *ngIf="!vm.isMobileWebView">
      <p i18n="@@fees.content.join">Join BitOasis and Start Trading now!</p>
      <ng-container *ngTemplateOutlet="startButton; context: { url }"></ng-container>
    </div>
  </ng-template>

  <ng-template #startButton let-url="url">
    <a *ngIf="!vm.isMobileWebView" [routerLink]="isLoggedIn() ? [url] : ['/register']" class="btn btn-primary" i18n="@@fees.content.started">Get Started</a>
  </ng-template>
</ng-container>

